import { RecurrenceType } from "./enums/recurrence-type.enum";
import { RecurrenceUnit } from "./enums/recurrence-unit.enum";

export class Recurrence {
    public id: number;
    public name: string;
    public value: number;
    public unit: RecurrenceUnit; // if type is time (week, month, ...)
    public type: RecurrenceType;

    constructor (recurrence: any = {}) {
        this.id = recurrence.id || 0;
        this.name = recurrence.name || 0;
        this.value = recurrence.value || 0;
        this.unit = recurrence.unit || 0;
        this.type = recurrence.type || 0;
    }
}
